// CheckboxControl.tsx
import React, { useEffect, useState } from 'react';
import { Checkbox, FormControl, FormControlLabel, FormHelperText } from '@mui/material';
import { FormModeType } from '@/components/FormDataProvider';
import { Control } from '../ControlRenderer';
import { get, set } from '../utils/Utils';
import { useValidation } from '@/components/ValidationProvider';

interface CheckboxControlProps {
  control: Control;
  data: any;
  onDataChange: (newData: any) => void;
  mode: FormModeType;
}

const CheckboxControl: React.FC<CheckboxControlProps> = ({ control, data, onDataChange, mode }) => {
  const { errors, validateData, setDataContext } = useValidation();
  const [selectedValue, setSelectedValue] = useState<boolean | undefined>(get(data, control.dataKey ?? '', undefined));

  const errorMessage = errors && control.dataKey ? errors[control.dataKey] : undefined;

  const isIndeterminate = selectedValue === undefined;

  const handleFieldChange = (fieldName: string, value: boolean | undefined) => {
    setSelectedValue(value);
    set(data, fieldName, value);
    onDataChange(data);
    validateData();
  };

  const handleClick = (e: React.MouseEvent) => {
    let currentMode = control.mode ? control.mode : mode;
    if (currentMode === 'view') {
      e.preventDefault();
      return; // Prevent changes in view mode
    }

    // Toggle indeterminate logic:
    if (!isIndeterminate && selectedValue === false) {
      handleFieldChange(control.dataKey ?? '', undefined);
      e.preventDefault();
    }
  };

  useEffect(() => {
    setSelectedValue(get(data, control.dataKey ?? '', undefined));
  }, [data, control.dataKey]);

  useEffect(() => {
    if (data) {
      setDataContext(data);
    }
  }, [data, setDataContext]);

  let currentMode = control.mode ? control.mode : mode;

  return (
    <>
      {errorMessage ? (
        <FormControl variant="standard" error><Checkbox
          checked={selectedValue === true}
          indeterminate={isIndeterminate}
          onChange={(e) => handleFieldChange(control.dataKey ?? '', e.target.checked)}
          color="primary"
          inputProps={{ readOnly: currentMode === 'view' }}
          onClick={handleClick}
        /><FormHelperText>{errorMessage}</FormHelperText></FormControl>
      ) : (
        <Checkbox
          checked={selectedValue === true}
          indeterminate={isIndeterminate}
          onChange={(e) => handleFieldChange(control.dataKey ?? '', e.target.checked)}
          color="primary"
          inputProps={{ readOnly: currentMode === 'view' }}
          onClick={handleClick}
        />
      )}
    </>
  );
};

export default CheckboxControl;